import {
  Button,
  handleGoHome,
  PageBody,
  Result,
  Stack,
} from '@pypestream/design-system';
import { FC } from 'react';

interface ErrorPageProps {
  label: string;
  body: string;
  buttonText?: string;
  buttonOnClick?: () => void;
}

export const ErrorPage: FC<ErrorPageProps> = ({
  label,
  body,
  buttonText = 'Go back home',
  buttonOnClick = () => handleGoHome({ accountId: undefined }),
}) => {
  return (
    <PageBody background="none">
      <Result align="center" status="error" label={label} body={body}>
        <Stack gutter="xsmall" justifyContent="center" slot="footer">
          <Button size="large" onClick={buttonOnClick}>
            {buttonText}
          </Button>
        </Stack>
      </Result>
    </PageBody>
  );
};
